import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UserServiceProxy } from '../../../../../shared/service-proxies/service-proxies';

@Component({
  selector: 'appdropdownpop',
  templateUrl: './dropdown-pop.component.html',
  styleUrls: ['./dropdown-pop.component.scss']
})
export class DropdownPopComponent implements OnInit {
    @ViewChild('appdownloadpopModel', { static: true }) modal: ModalDirective;
    active = false;
    saving = false;

    showModal: boolean;
    carddata = [{ id: '1', name: 'Windows Agent', img: '../../../assets/common/images/login/WindowNew.svg' },
    { id: '2', name: 'MAC Agent', img: '../../../assets/common/images/login/MacNew.svg' },
    { id: '3', name: 'Android App', img: '../../../assets/common/images/login/Android App.svg' },
    { id: '4', name: 'IOS App', img: '../../../assets/common/images/login/IOS App.svg' }
    ];

    constructor(private userServiceProxy: UserServiceProxy) { }

  ngOnInit(): void {
  }

    downloadAgentAppWindows(item) {
        alert(item);
        if (item.id === '1') {
            this.userServiceProxy.downloadAgentAppWindows().subscribe();
        }
    }

    show(): void {
        this.active = true;
        this.modal.show();
    }

    save(): void {

    }
    close(): void {
        this.active = false;
        this.modal.hide();
    }

    public skip() {

    }

    next() {
        let x = document.getElementById('card1');
        let y = document.getElementById('card2');
        if (x.style.display === 'none') {
            x.style.display = 'block';
            y.style.display = 'none';

        } else {
            x.style.display = 'none';
            y.style.display = 'block';
        }
    }

    back1() {
        let x = document.getElementById('card1');
        let y = document.getElementById('card2');
        if (x.style.display === 'block') {
            x.style.display = 'none';
            y.style.display = 'block';

        } else {
            x.style.display = 'block';
            y.style.display = 'none';
        }


    }

    next1() {
        let x = document.getElementById('card2');
        let y = document.getElementById('card3');
        if (x.style.display === 'none') {
            x.style.display = 'block';
            y.style.display = 'none';

        } else {
            x.style.display = 'none';
            y.style.display = 'block';
        }


    }

    back2() {

        let x = document.getElementById('card2');
        let y = document.getElementById('card3');
        if (x.style.display === 'block') {
            x.style.display = 'none';
            y.style.display = 'block';

        } else {
            x.style.display = 'block';
            y.style.display = 'none';
        }


    }

    back3() {
        let x = document.getElementById('card3');
        let y = document.getElementById('card4');
        if (x.style.display === 'none') {
            x.style.display = 'block';
            y.style.display = 'none';

        } else {
            x.style.display = 'none';
            y.style.display = 'block';
        }

    }
    next2() {

        let x = document.getElementById('card3');
        let y = document.getElementById('card4');
        if (x.style.display === 'block') {
            x.style.display = 'none';
            y.style.display = 'block';

        } else {
            x.style.display = 'block';
            y.style.display = 'none';
        }

    }

    next3() {

        this.showModal = false;

    }



    testClick() {

        alert('Click Test');

    }
}
